export const themes = {
  default: {
    thRoot: 'flex w-full pt-2',
    thContent: 'bg-white flex flex-wrap content-center h-full w-full',
    thButton: 'absolute left-0 right-0 bottom-0 flex justify-center',
    thPlaceholders: 'relative w-full',
  },
};
